export enum DeleteAccountModalFlow {
  DeleteAccount = 'DeleteAccount',
  ResetPassword = 'ResetPassword',
}
